const GetEMEASectorSiteCardReducer = (state = { type: 'LOADING_EMEA_SECTOR_SITE_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_EMEA_SECTOR_SITE_CARD_ACTION':
            return action
        case 'RESET_EMEA_SECTOR_SITE_CARD_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetOneNASectorSiteCardReducer = (state = { type: 'LOADING_NA_SECTOR_SITE_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_NA_SECTOR_SITE_CARD_ACTION':
            return action
        case 'RESET_NA_SECTOR_SITE_CARD_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}
const GetGlobalPackagingSectorSiteCardReducer = (state = { type: 'LOADING_GLOBAL_PACKAGING_SECTOR_SITE_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_GLOBAL_PACKAGING_SECTOR_SITE_CARD_ACTION':
            return action
        case 'RESET_GLOBAL_PACKAGING_SECTOR_SITE_CARD_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}

const GetSupplierPassportSectorSiteCardReducer = (state = { type: 'LOADING_SUPPLIER_PASSPORT_SECTOR_SITE_CARD_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_SUPPLIER_PASSPORT_SECTOR_SITE_CARD_ACTION':
            return action
        case 'RESET_SUPPLIER_PASSPORT_SECTOR_SITE_CARD_ACTION':
            return {
                ...state,
                type: action.payload
            };  
        default:
            return state
    }
}


export {
    GetEMEASectorSiteCardReducer,
    GetOneNASectorSiteCardReducer,
    GetGlobalPackagingSectorSiteCardReducer,
    GetSupplierPassportSectorSiteCardReducer,
}